import React, { useEffect, useMemo, useState } from 'react';
import { Table, Tag, Space, Select, Input, DatePicker, Button, message } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { stokHareketleriAPI } from '../services/api';
import { formatSayi } from '../utils/format';

const HAREKET_TIPI_RENK = {
  uretim_cikti: 'geekblue',
  satis: 'red',
};

const HAREKET_TIPI_ETIKET = {
  uretim_cikti: 'Üretim Çıktı',
  satis: 'Satış',
};

function StokHareketleriTab() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [arama, setArama] = useState('');
  const [tipFiltre, setTipFiltre] = useState(null);
  const [tarihAralik, setTarihAralik] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {};
      if (tipFiltre) params.hareket_tipi = tipFiltre;
      if (tarihAralik && tarihAralik[0]) params.baslangic = tarihAralik[0].format('YYYY-MM-DD 00:00:00');
      if (tarihAralik && tarihAralik[1]) params.bitis = tarihAralik[1].format('YYYY-MM-DD 23:59:59');
      const res = await stokHareketleriAPI.urun(params);
      setData(res.data);
    } catch (err) {
      message.error('Stok hareketleri yüklenemedi: ' + (err.response?.data?.hata || err.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, [tipFiltre, tarihAralik]);

  const filteredData = useMemo(() => {
    if (!arama) return data;
    const q = arama.toLowerCase();
    return data.filter(r =>
      (r.urun_ad || '').toLowerCase().includes(q) ||
      (r.aciklama || '').toLowerCase().includes(q) ||
      (r.hareket_tipi || '').toLowerCase().includes(q)
    );
  }, [data, arama]);

  const tipOptions = useMemo(() => {
    const seen = new Set();
    data.forEach(r => r.hareket_tipi && seen.add(r.hareket_tipi));
    return Array.from(seen).map(t => ({ value: t, label: HAREKET_TIPI_ETIKET[t] || t }));
  }, [data]);

  const columns = [
    { title: 'Tarih', dataIndex: 'tarih', key: 'tarih', width: 150, render: (v) => v ? dayjs(v).format('DD.MM.YYYY HH:mm') : '-' },
    { title: 'Ürün', dataIndex: 'urun_ad', key: 'ad', render: (v) => v || <span style={{ color: '#999' }}>-</span> },
    {
      title: 'Hareket Tipi',
      dataIndex: 'hareket_tipi',
      key: 'hareket_tipi',
      width: 150,
      render: (v) => <Tag color={HAREKET_TIPI_RENK[v] || 'default'}>{HAREKET_TIPI_ETIKET[v] || v}</Tag>,
    },
    { title: 'Miktar', dataIndex: 'miktar', key: 'miktar', width: 100, align: 'right', render: (v) => formatSayi(v, 2) },
    { title: 'Birim', dataIndex: 'birim', key: 'birim', width: 80 },
    { title: 'Üretim #', dataIndex: 'uretim_id', key: 'uretim_id', width: 90, render: (v) => v || '-' },
    { title: 'Satış #', dataIndex: 'satis_id', key: 'satis_id', width: 90, render: (v) => v || '-' },
    { title: 'Açıklama', dataIndex: 'aciklama', key: 'aciklama' },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }} wrap>
        <Select
          allowClear
          placeholder="Hareket Tipi"
          style={{ width: 180 }}
          options={tipOptions}
          value={tipFiltre}
          onChange={setTipFiltre}
        />
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          value={tarihAralik}
          onChange={setTarihAralik}
        />
        <Input
          placeholder="Ara..."
          prefix={<SearchOutlined />}
          allowClear
          value={arama}
          onChange={(e) => setArama(e.target.value)}
          style={{ width: 220 }}
        />
        <Button icon={<ReloadOutlined />} onClick={fetchData}>Yenile</Button>
      </Space>

      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={{ defaultPageSize: 20, pageSizeOptions: ['10', '20', '50', '100'], showSizeChanger: true, showTotal: (t, r) => `${r[0]}-${r[1]} / ${t} kayıt` }}
      />
    </div>
  );
}

export default StokHareketleriTab;
